import React, { useState, useEffect, useRef, useMemo, forwardRef, useImperativeHandle } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";
import ImageResize from "quill-image-resize-module-react";

Quill.register("modules/imageResize", ImageResize);

const CustomEditor = forwardRef(({ value, onChange }, ref) => {
  const [editorValue, setEditorValue] = useState("");
  const quillRef = useRef(null);

  useEffect(() => {
    setEditorValue(value || "");
  }, [value]);

  useImperativeHandle(ref, () => ({
    setData: (data) => setEditorValue(data),
  }));

  const handleImageUpload = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("image", file);

      // Use .env variables
    const apiBaseUrl =
    window.location.origin.includes("localhost")
      ? process.env.REACT_APP_API_URL_LOCAL
      : process.env.REACT_APP_API_URL_PROD;

      try {
        const response = await fetch(`${apiBaseUrl}/api/upload-image`, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();
        if (data.uploaded) {
          const editor = quillRef.current.getEditor();
          const range = editor.getSelection();
          if (range) {
            editor.insertEmbed(range.index, "image", data.url);
          }
        } else {
          console.error("Upload failed:", data.error);
        }
      } catch (error) {
        console.error("Image upload failed:", error);
      }
    };
  };

  const handleEditorChange = (content) => {
    setEditorValue(content);
    onChange && onChange(content);
  };

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "code-block"],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
        ["clean"],
      ],
      handlers: { image: handleImageUpload },
    },
    imageResize: { modules: ["Resize", "DisplaySize", "Toolbar"] },
  }), []);

  return <ReactQuill ref={quillRef} value={editorValue} onChange={handleEditorChange} modules={modules} />;
});

export default CustomEditor;
